<template>
	<div>
		<div class="container">
			<div class="page-header">
				<!-- <h3 class="title is-3 has-text-left">Mensagem de inspiração para seus pacientes</h3> -->
			</div>
			<div class="page-content">
				<div v-for="category in categories" :key="category.id" class="marketing-category">
					<h4 class="title is-4 has-text-left">{{category.name}}</h4>
					<div class="columns is-mobile is-multiline">
						<div class="column is-6-mobile is-4-tablet is-2-desktop" v-for="post in categoryPosts(category.id)" :key="post.id">
							<div class="marketing-post"  @click="useTemplate(post)">
								<img :src="post.thumbnail" />
							</div>
						</div>
					</div>

				</div>
		</div>
		</div>
	</div>

</template>


<style scoped>
	.page-content { margin-bottom:80px}
	.marketing-category { margin-bottom:40px}
	.marketing-post { border:1px solid #ccc; cursor: pointer; }
	.marketing-post img { display:block;}
	@media screen and (max-width: 1199px){
		.page-header{
			padding-top: 80px;
			margin-top: unset;
		}
	}
</style>

<script>

import axios from 'axios';

export default {

	data() {
		return {
			categories:[],
			posts:[]
		}
	},



	methods:{
		useTemplate(post){
			this.$router.push({name:'marketingPost',params:{id:post.id, post:post}})
		},

		getPosts () {
			axios.get('posts.json').then(res=>{
				this.posts = res.data;
			})
		},

		categoryPosts(category_id){
			return this.posts.filter(post=> post.category_id==category_id);
		},

		getCategories () {
			axios.get('categories.json').then(res=>{
				this.categories = res.data;
			});
		},
	},
	mounted () {
		this.getCategories();
		this.getPosts();
	},



};
</script>
